var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__container auth__transition d-flex align-center justify-center",class:[_vm.isLoading ? '' : 'loader__hidden']},[_c('v-progress-circular',{attrs:{"size":60,"indeterminate":"","color":"#1F837A"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }